import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { QueryParams } from "@ui/navigation/routes";

// TODO Every extracted query param value is a string in the end, despite the types specified in the code
export function useQueryParams<R extends keyof QueryParams>(): Partial<QueryParams[R]> {
	const location = useLocation();
	return useMemo(() => {
		const result = {};
		new URLSearchParams(location.search).forEach((value, key) => Object.assign(result, { [key]: value }));
		return result;
	}, [location]);
}
